import React from 'react';
import ReactPlayer from 'react-player';
import Box from '@mui/material/Box';

export function VideoViewer({ video_url }) {
  return (
    <Box
      sx={{
        position: 'relative',
        paddingTop: '56.25%',
        width: '100%',
        height: 0,
      }}
    >
      <Box
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        <ReactPlayer
          url={video_url}
          controls={true}
          playsinline={true}
          muted={false}
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  );
}
